/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AreaV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The name of the area for internal use
   */
  name: string;
  /**
   * The type of the area.
   */
  type: AreaV1Dto.type;
  /**
   * The type of use of the area.
   */
  typeOfUse: AreaV1Dto.typeOfUse;
  /**
   * The size of the area in square meters
   */
  size: number;
  /**
   * The area is valid from.
   */
  validFrom?: string | null;
  /**
   * The area is valid to.
   */
  validTo?: string | null;
  /**
   * The uuid of the location linked to this area. As 8-4-4-4-12 format.
   */
  locationId: string;
};
export namespace AreaV1Dto {
  /**
   * The type of the area.
   */
  export enum type {
    MAIN_AREA = 'main_area',
    ANCILLARY_AREA = 'ancillary_area',
  }
  /**
   * The type of use of the area.
   */
  export enum typeOfUse {
    SALES = 'sales',
    STORAGE = 'storage',
    AD_SPACE = 'ad_space',
    PARKING_AREA = 'parking_area',
    CONCESSION_AREA = 'concession_area',
    OFFICE_ADMINISTRATION = 'office_administration',
    PRACTICE = 'practice',
    LOGISTIC = 'logistic',
    GASTRONOMY = 'gastronomy',
    OTHER_APARTMENTS = 'other_apartments',
    OTHER_USE = 'other_use',
  }
}
